"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var siteNavigationStyles = require("spry-react/Page/siteNavigationStyles");
var classNames = require("classnames");
require("./siteNavigation.less");
var contextMenu_1 = require("spry-react/ContextMenu/contextMenu");
var link_1 = require("spry-react/Link/link");
var SiteNavigation = /** @class */ (function (_super) {
    __extends(SiteNavigation, _super);
    function SiteNavigation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SiteNavigation.prototype.render = function () {
        var siteLinks = this.props.siteLinksContent || React.createElement("a", { title: "Home", href: "/Home" },
            React.createElement("i", { className: "home-icon" }));
        return React.createElement("nav", { id: "site-top-nav" },
            React.createElement("div", { className: "nav-left" }, siteLinks),
            React.createElement("div", { className: "nav-right" }, this.props.navContent));
    };
    return SiteNavigation;
}(React.PureComponent));
exports.SiteNavigation = SiteNavigation;
var SiteNavigationLink = /** @class */ (function (_super) {
    __extends(SiteNavigationLink, _super);
    function SiteNavigationLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SiteNavigationLink.prototype.render = function () {
        var classes = classNames(this.props.iconClassName, this.props.disabled ? "disabled" : undefined);
        return React.createElement("div", { id: this.props.id, title: this.props.title, className: siteNavigationStyles.siteNavLink, disabled: this.props.disabled, onClick: this.props.disabled ? function () { } : this.props.onClick },
            React.createElement(link_1.Link, { onClick: null, className: classes, style: { display: "inline-block", width: "auto", marginRight: "auto" }, disabled: this.props.disabled }, this.props.text));
    };
    return SiteNavigationLink;
}(React.PureComponent));
exports.SiteNavigationLink = SiteNavigationLink;
function SiteNavigationContextMenuLink(props) {
    var classes = classNames(props.iconClassName, props.disabled ? "disabled" : undefined);
    return React.createElement(React.Fragment, null,
        React.createElement(contextMenu_1.ContextMenuTrigger, { openContextMenu: props.openContextMenu, disabled: props.disabled },
            React.createElement("div", { id: props.id, title: props.title, className: siteNavigationStyles.siteNavLink, disabled: props.disabled },
                React.createElement("a", { className: classes, style: { display: "inline-block", width: "auto", marginRight: "auto" } }, props.text))));
}
exports.SiteNavigationContextMenuLink = SiteNavigationContextMenuLink;
